import { ElMessage } from "element-plus"

export const teacher = {
    state: () => ({
        teachers: [],
        teacherRules: {
            fullname: [{ required: true, message: "F.I.SH. ni kiriting" }],
            phone: [{ required: false }],
        },
    }),
    getters: {
        teachers({teachers}){
            return teachers
        },
        teacherRules({teacherRules}){
            return teacherRules
        },
    },
    mutations:{
        teachers(state,payload){
            state.teachers = payload
        },
        addTeacher(state,payload){
            state.teachers = [payload,...state.teachers]
        },
        deleteTeacher(state,payload){
            state.teachers = state.teachers.filter(teacher => teacher._id !== payload)
        },
        upTeacher(state,payload){
            state.teachers = state.teachers.map(teacher => {
                if (teacher._id === payload._id) return payload
                return teacher
            })
        }
    },
    actions:{
        getTeacher({dispatch},payload){
            return dispatch('getAxios',{
                url: `teacher/edit/${payload}`
            })
        },
        async getTeachers({dispatch,commit}){
            let res = await dispatch('getAxios',{
                url:'teacher'
            })
            if (res.status === 200){
                commit('teachers',res.data)
            }
        },
        async saveTeacher({dispatch,commit},payload){
            let res = await dispatch('putAxios',{
                url: `teacher`,
                data: payload
            })
            if (res.status == 200){
                commit('upTeacher',{...res.data})
            }
        },
        async statusTeacher({ dispatch, commit }, payload) {
            let res = await dispatch('getAxios', { url: `teacher/status/${payload}` });
            if (res.status == 200) {
                commit('upTeacher', res.data);
                ElMessage({
                    message: `O'qituvchi holati o'zgartirildi`,
                    type: 'success',
                });
            }
        },
        async addTeacher({dispatch,commit},payload){
            let res = await dispatch('postAxios',{
                url:'teacher',
                data: payload
            })
            if (res.status==201){
                commit('addTeacher',res.data)
            }
        },
        async deleteTeacher({dispatch,commit},payload){
            let res = await dispatch('deleteAxios', `teacher/${payload}`)
            if (res.status==200){
                commit('deleteTeacher',payload)
                ElMessage({
                    message: `O'qituvchi o'chirildi`,
                    type: 'success',
                });
            }
        }
    }
}
